import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFaceSad16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconFaceSad16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0m1 0A7 7 0 1 1 1 8a7 7 0 0 1 14 0m-9.275-.7a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75m5.425-.875a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0M4.82 12.18a.5.5 0 0 0 .646-.28l.002-.006.016-.035q.024-.051.083-.15c.08-.13.21-.308.4-.487C6.34 10.873 6.97 10.5 8 10.5s1.66.373 2.034.722a2.4 2.4 0 0 1 .483.637l.016.035.002.005a.5.5 0 0 0 .931-.366l-.466.181.466-.181v-.001l-.001-.001-.001-.004-.004-.008-.01-.023-.034-.074a3 3 0 0 0-.13-.238 3.4 3.4 0 0 0-.57-.692C10.174 9.984 9.305 9.5 8 9.5s-2.173.484-2.716.992c-.268.25-.451.501-.57.692a3 3 0 0 0-.165.312l-.01.023-.003.008-.001.004v.002l.465.181-.466-.18a.5.5 0 0 0 .285.646"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFaceSad16);
